export const formatStatisticNumber = (num: number): string => {
  if (Number.isNaN(num)) return '-';

  if (num < 1000) {
    return num.toString();
  } else if (num < 10000) {
    return num.toLocaleString('uk-UA');
  } else {
    return (
      (num / 1000).toLocaleString('uk-UA', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }) + ' тис.'
    );
  }
};
